// Sales of one organization (or, for the admin, of every one): the
// framework's sales report (aldoo-ra/StoreSales) over aldoo.com's sales API —
// a seller reads their own products, with the product views aldoo.com counts
// — in the vendor portal's words. The share, the next payout and what was paid
// are in Payouts.
import React from "react"
import StoreSales from "aldoo-ra/StoreSales"
import { SalesReport, SalesSeries } from "../AdminShared/api"
import usePortalTexts from "../Vendor/texts/usePortalTexts"
import { SALES } from "../Vendor/texts/bundles"

const API = { report: SalesReport, series: SalesSeries }
const useTexts = () => usePortalTexts(SALES)

// the help center's article on the report (aldoo-com-api scripts/help-center/vendor/articles/sales-figures.html):
// the whole of it beside the title, its "Fields of the chart" section in the dialog, a figure's section on its tile
const HELP = { sales: "vendor.sales.figures", fields: "vendor.sales.figures#fields", metric: (key) => `vendor.sales.figures#${key}` }

export default function SalesTab({ orgId, timeZone }) {
  return <StoreSales orgId={orgId || null} timeZone={timeZone} api={API} useTexts={useTexts} helpKeys={HELP} />
}
